import { css, styled } from "../../../../styles";

export const ModalContainer = styled("div", {
  width: "100%",
  height: "100%",
});

export const FormsContainer = styled("div", {
  height: "100%",
  width: "512px",
  maxHeight: "512px",
  minHeight: "312px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  padding: "24px 0px",

  color: "$black",
  fontFamily: "$openSans",
  fontWeight: 400,
  fontSize: 18,
});

export const FormOption = styled("div", {
  width: "100%",
  height: "106px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  cursor: "pointer",
});

export const Divider = styled("div", {
  width: "calc(100% + 32px)",
  height: "1px",
  backgroundColor: "$gray-50",
  marginLeft: "-16px",
});

export const LoadingContainer = styled("div", {
  width: "100%",
  height: "100%",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const AnswerSurveyContainer = styled("div", {
  height: "calc(100vh - 62px)",
  width: "100vw",

  display: "flex",
  justifyContent: "center",

  marginTop: 62,

  backgroundColor: "$white",
});

// CSS

export const spinCss = css({
  backgroundColor: "white !important",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  ".ant-spin-dot": {
    ".ant-spin-dot-item": {
      backgroundColor: "var(--colors-portal-loading-state-color)",
    },
  },
});
